import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import userReducer from "../reducers/userReducer";
import pageReducer from "../reducers/pageReducer";
import chatReducer from "reducers/chatReducer";
import carReducer from "reducers/carReducer";
import reloadReducer from "reducers/reloadReducer";
import reportReducer from "reducers/reportReducer";
import statReducer from "reducers/statReducer";
import requestReducer from "reducers/requestReducer";
import notificationReducer from "reducers/notificationReducer";

export const store = configureStore({
  reducer: {
    user: userReducer,
    page: pageReducer,
    chat: chatReducer,
    car: carReducer,
    reload: reloadReducer,
    report: reportReducer,
    stat: statReducer,
    request: requestReducer,
    notification: notificationReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
